import { SessionContext } from '@contexts/session-context';
import { UserService } from '@services/user.service';
import {
  Button,
  Icon,
  Modal,
  TextArea,
  toastify,
  useTranslation,
} from '@testsigma/atoms';
import classNames from 'classnames';
import { useCallback, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FeedbackModel } from '../../models/feedback.model';

interface FeedbackPros {
  isOpenFeedback: boolean;
  updateIsOpenFeedback: (value: boolean) => void;
}

export const FeedBack: React.FC<FeedbackPros> = ({
  isOpenFeedback,
  updateIsOpenFeedback,
}) => {
  const location = useLocation();
  const { t } = useTranslation();
  const ratings = [1, 2, 3, 4, 5];
  const [description, updateDescription] = useState('');
  const { session } = useContext(SessionContext);

  const setDescription = useCallback(
    (desc) => {
      updateDescription(desc);
    },
    [updateDescription],
  );

  const [ratingGiven, setRatingGiven] = useState(3);

  const handleRatingClick = (number) => {
    setRatingGiven(number);
  };

  const sendFeedBack = useCallback(() => {
    const feedback = new FeedbackModel();
    feedback.description = description;
    feedback.rating = ratingGiven;
    feedback.pageUrl = location.pathname;
    feedback.userId = session.user.id;
    UserService.shareFeedback(session.user.id, feedback)
      .then(() => {
        updateIsOpenFeedback(false);
        toastify(t('feedback.successful'), {
          type: 'success',
          hideProgressBar: true,
        });
      })
      .catch(() => {
        toastify(t('feedback.unsuccessful'), {
          type: 'error',
          hideProgressBar: true,
        });
      });
  }, [ratingGiven, description]);

  return (
    <>
      <Modal
        isOpen={isOpenFeedback}
        className='!rounded-lg !w-1/3 text-unique-600'>
        <div className='flex items-center'>
          <div className='text-lg text-unique-600 font-medium'>
            {t('feedback.title')}
          </div>
        </div>
        <div className='pt-4 pb-5 text-small leading-5'>
          {t('feedback.note')}
        </div>
        <div className='pb-5'>
          <div className='flex justify-between'>
            {ratings.map((number) => (
              <span
                key={number}
                onClick={() => handleRatingClick(number)}
                className={classNames(
                  'px-5 py-2.5 rounded cursor-pointer bg-neutral-200 text-white',
                  {
                    '!bg-warning-100 !text-warning-500': number <= ratingGiven,
                  },
                )}>
                <Icon className='text-2xl' name='filled-star' />
              </span>
            ))}
          </div>
          <div className='flex items-center pt-2 text-xs'>
            <div>{t('feedback.not_good')}</div>
            <div className='ml-auto'>{t('feedback.like')}</div>
          </div>
        </div>
        <div>
          <div className='pt-5 text-small leading-5'>{t('feedback.des')}</div>
          <TextArea
            id='req-description'
            label={t('common.description')}
            value={description}
            onChange={(data) => setDescription(data)}
            wrapperClassName='w-full mt-4'
            inputClassName='!py-3'
          />
        </div>
        <div className='flex flex-row-reverse gap-3 pt-10'>
          <Button type='primary' onClick={() => sendFeedBack()}>
            {t('feedback.submit_btn')}
          </Button>

          <Button type='secondary' onClick={() => updateIsOpenFeedback(false)}>
            {t('cancel')}
          </Button>
        </div>
      </Modal>
    </>
  );
};
